// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__CKhTB","form":"styles_form__2lIlj"};